import {RequestInfo} from "@repo/shared-core";

const MESSAGE =
    "\nInterested in working with us?\nSee https://www.khanacademy.org/careers.\n\n";

/**
 * Display recruiting message in the browser console.
 */
export default function () {
    if (
        !RequestInfo.IS_DEV_SERVER &&
        typeof window !== "undefined" &&
        window.console
    ) {
        /**
         * NOTE: We don't use our centralized logging here because we ALWAYS
         * want to display this to our users.
         */
        console.log(MESSAGE); // eslint-disable-line no-console -- we want to display this to our users
    }
}
